enum Mutations {
  SET_TAGS = 'setTags',
  UPDATE_TAGS = 'updateTags',
  DELETE_TAGS = 'deleteTags',
  SET_SELECTED_TAG_IDS = 'setSelectedTagIds',
}

export default Mutations;
